/**
 * Author：brand
 * Creation Time：2019-05-13 15:51
 * Email：brandhuang@qq.com
 */
import { asyncRoutes, constantRoutes, errorRoute } from '@/router/router'
import {routerMap} from '@/router/router-map'

const state = {
  routes: constantRoutes,
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, data) {
    return new Promise(resolve => {
      let accessedRouters = []
      if (data && data.length > 0) {
        accessedRouters = asyncRoutes.concat(errorRoute)
        accessedRouters.map( menuRes => {
          if(menuRes.name == 'layout'){
            menuRes.children = mergeArray(menuRes.children, data) // 有菜单数据替换默认菜单
            menuRes.redirect = menuRes.children[0].path
          }
        })
      }else {
        accessedRouters = accessedRouters.concat(errorRoute)
      }
      commit('SET_ROUTES', accessedRouters)
      resolve(accessedRouters)
    })
  }
}

function mergeArray(arr1, arr2) {
  const arr3 = []
  arr1.forEach(e => {
    arr2.forEach(v => {
      if (e.path === v.path) {
        if(e.meta.hideChildMenu){
          if(e.children.length > 0){
            e.redirect = e.children[0].path
          }
          arr3.push(e)
        }else {
          if (e.children && v.children) {
            if(!e.meta.hasFourth){
              const new_arr = mergeArray(e.children, v.children)
              e.children = []
              e.children = e.children.concat(new_arr)
              if(e.children.length > 0){
                e.redirect = e.children[0].path
              }
            }else {
              if(e.children.length > 0){
                e.redirect = e.children[0].path
              }
            }
            arr3.push(e)
          } else {
            if(e.children.length > 0){
              e.redirect = e.children[0].path
            }
            arr3.push(e)
          }
        }

      }
    })
  })
  return arr3
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
